import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);

export function CartProvider({ slug, children }) {
  const key = `vp_cart_${slug}`;
  const [items, setItems] = useState([]);

  useEffect(() => {
    try { setItems(JSON.parse(localStorage.getItem(key)) || []); } catch { setItems([]); }
  }, [key]);

  const persist = useCallback((next) => { setItems(next); localStorage.setItem(key, JSON.stringify(next)); }, [key]);

  const addItem = (it) => {
    const k = `${it.product_id}-${it.color}-${it.size}`;
    const ex = items.find((i) => `${i.product_id}-${i.color}-${i.size}` === k);
    if (ex) persist(items.map((i) => (`${i.product_id}-${i.color}-${i.size}` === k ? { ...i, qty: i.qty + it.qty } : i)));
    else persist([...items, it]);
  };
  const updateQty = (idx, d) => persist(items.map((i, x) => (x === idx ? { ...i, qty: Math.max(1, i.qty + d) } : i)));
  const removeItem = (idx) => persist(items.filter((_, x) => x !== idx));
  const clear = () => persist([]);

  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count }}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
